import { Component } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "app-wizard-check-to-close-modal",
  templateUrl: "./wizard-check-to-close-modal.component.html",
  styleUrls: ["./wizard-check-to-close-modal.component.scss"],
})
export class WizardCheckToCloseModalComponent {
  constructor(private dialogRef: NbDialogRef<WizardCheckToCloseModalComponent>) {}

  closeModal(value) {
    this.dialogRef.close(value);
  }
}
